/**
 * What the server writes as the sender name of the messages of a deleted account
 * (functions/app, account deletion). It is stored once, in English, in every message: the app shows
 * the name in its own language instead.
 */
export const DELETED_USER_NAME = 'Deleted user';

export function isDeletedUserName(name: unknown): boolean {
  return name === DELETED_USER_NAME;
}

/** The name to show: translated for a deleted account, as stored for everyone else. */
export function displayedSenderName(name: string | undefined, translated: string): string {
  return isDeletedUserName(name) ? translated : name || '';
}
